import { ISeasonAward } from '../../../store/admin/seasonAwards/store';

export const awardMotif = (award: ISeasonAward) =>
  award.roundNumber ? `(R${award.roundNumber})` : '(F)';
